function getLabel(array, element) {
  return array.filter((value) => { return value.data == element })[0].label;
}

function hoje() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if(dd < 10) { dd = '0' + dd }
  if(mm < 10) { mm = '0' + mm }

  return dd + '/' + mm + '/' + yyyy;
}

function agora() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  var hh = today.getHours();
  var MM = today.getMinutes();

  if(dd < 10) { dd = '0' + dd }
  if(mm < 10) { mm = '0' + mm }
  if(hh < 10) { hh = '0' + hh }
  if(MM < 10) { MM = '0' + MM }

  return dd + '/' + mm + '/' + yyyy + " " + hh + ":" + MM;
}

function formatarEnderecoImovel(imovel) {
  if(imovel == undefined || imovel.id == 0) { return ""; }

  let texto = "(" + imovel.idNaImobiliaria + ") " +
    (imovel.tipoImovel !== undefined ? imovel.tipoImovel.nome + " - " : "")
    + imovel.endereco;

  let numeroEndereco = imovel.numeroEndereco;
  if(numeroEndereco != undefined) { texto += ", " + numeroEndereco; }

  let bairro = imovel.bairro.nome;
  if(bairro != undefined) { texto += " (" + bairro + ")"; }

  return texto;
}

function formatarValor(value) {
  // return "R$ " + Number(valor.toFixed(2)).toLocaleString("pt-BR");
    let val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

export default {
  getLabel,
  formatarEnderecoImovel,
  hoje,
  agora,
  formatarValor
}